export enum UserStatisticsType {
  NO_PROJECT = 'no-project',
  WITH_PROJECT = 'with-project',
}
export const UserStatisticsTypeTranslation = {
  'no-project': 'Nieprzypisane do projektu',
  'with-project': 'Przypisane do projektu',
};
